import { render, staticRenderFns } from "./Util-Item-Downtime.vue?vue&type=template&id=5d8021c4"
import script from "./Util-Item-Downtime.vue?vue&type=script&lang=js"
export * from "./Util-Item-Downtime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports